import type { SoundId } from '../types/anna';

let audioCtx: AudioContext | null = null;

function getContext(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  const AC =
    window.AudioContext ||
    (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AC) return null;
  if (!audioCtx) audioCtx = new AC();
  if (audioCtx.state === 'suspended') void audioCtx.resume();
  return audioCtx;
}

function tone(
  ctx: AudioContext,
  freq: number,
  offset: number,
  duration: number,
  type: OscillatorType,
  peak: number,
  endFreq?: number,
) {
  const t0 = ctx.currentTime + offset;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  if (endFreq) osc.frequency.exponentialRampToValueAtTime(endFreq, t0 + duration * 0.6);
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.linearRampToValueAtTime(peak, t0 + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + duration);
  osc.connect(gain).connect(ctx.destination);
  osc.start(t0);
  osc.stop(t0 + duration + 0.05);
}

/** Soft chime for "meldt", low tone for "geweigerd", short rising tone for "klaar". */
export function playSound(id: SoundId) {
  const ctx = getContext();
  if (!ctx) return;
  if (id === 'meldt') {
    tone(ctx, 1046.5, 0, 1.4, 'sine', 0.1);
    tone(ctx, 1568, 0, 0.9, 'sine', 0.035);
    tone(ctx, 784, 0.1, 1.2, 'sine', 0.05);
  } else if (id === 'geweigerd') {
    tone(ctx, 174.6, 0, 0.5, 'triangle', 0.14, 150);
  } else {
    tone(ctx, 587, 0, 0.22, 'sine', 0.1, 880);
    tone(ctx, 880, 0.15, 0.35, 'sine', 0.06);
  }
}
